/**
 * Service for managing installation builds
 */export class InstallationBuildsService{constructor(api){this.api=void 0;this.api=api;}/**
   * Get all builds for an installation
   */async getBuilds(installationId){let limit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:50;let skip=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;return this.api.get(`/api/v2/apps/${installationId}/builds`,{limit,skip});}/**
   * Get a single build by ID
   */async getBuild(buildId){return this.api.get(`/api/builds/${buildId}`);}/**
   * Get the latest deployed build for an installation in a specific environment
   */async getLatestDeployedBuild(installationId,env){return this.api.get(`/api/apps/${installationId}/builds/${env}/latest`);}/**
   * Create a new build
   */async createBuild(params){return this.api.post(`/api/builds`,params);}/**
   * Delete a build
   */async deleteBuild(buildId){return this.api.delete(`/api/builds/${buildId}`);}/**
   * Deploy a build to an environment
   */async deployBuild(buildId,environmentName){return this.api.post(`/api/builds/${buildId}/deploy`,{environmentName});}}